const OPEN_CLASS = 'is-open';

class ProductStack extends HTMLElement {
  connectedCallback() {
    // Touch browsers dispatch the follow-up `click` as a compatibility mouse
    // event, so `click.pointerType` reports "mouse" (or nothing) on a tap. The
    // real input is only reliable on `pointerdown`, so record it there.
    this.handlePointerdown = (event) => {
      this.pointerType = event.pointerType;
    };

    this.handleClick = (event) => {
      const pointerType = this.pointerType;
      this.pointerType = null;

      // No pointer preceded this click — keyboard or assistive activation.
      if (!pointerType) return;

      // Mouse users already see the stack fanned open on hover.
      if (pointerType === 'mouse') return;

      // Once fanned open, a tap on a card navigates to that product.
      if (this.classList.contains(OPEN_CLASS)) return;

      event.preventDefault();
      this.open();
    };

    this.handleKeydown = (event) => {
      if (event.key !== 'Escape') return;

      this.close();
    };

    this.handleDocumentPointerdown = (event) => {
      if (this.contains(event.target)) return;

      this.close();
    };

    this.addEventListener('pointerdown', this.handlePointerdown);
    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerdown', this.handlePointerdown);
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('pointerdown', this.handleDocumentPointerdown);
  }

  open() {
    this.classList.add(OPEN_CLASS);
    document.addEventListener('pointerdown', this.handleDocumentPointerdown);
  }

  close() {
    if (!this.classList.contains(OPEN_CLASS)) return;

    this.classList.remove(OPEN_CLASS);
    document.removeEventListener('pointerdown', this.handleDocumentPointerdown);
  }
}

if (!customElements.get('product-stack')) {
  customElements.define('product-stack', ProductStack);
}
